import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DownloadCandidateComplianceFile } from 'services/ComplianceService';

export default function ComplianceFileDownloadPage() {
  const [errorMessage, setErrorMessage] = useState('');
  const [isFileDownloaded, setIsFileDownloaded] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  const candidateId = useMemo(() => {
    const parsedId = +(params.id ?? '0');
    if (isNaN(parsedId)) return 0;
    return parsedId;
  }, [params.id]);

  const complianceItemId = useMemo(() => {
    const parsedId = +(params.cid ?? '0');
    if (isNaN(parsedId)) return 0;
    return parsedId;
  }, [params.cid]);

  useEffect(() => {
    const getFile = async () => {
      await DownloadCandidateComplianceFile(candidateId, complianceItemId, setErrorMessage);
      setIsFileDownloaded(true);
    };
    Boolean(candidateId) && Boolean(complianceItemId) && getFile();
  }, [candidateId, complianceItemId]);

  useEffect(() => {
    if (isFileDownloaded && !errorMessage) {
      const redirectUrl = `/candidates/${candidateId}?tab=Compliance`;
      navigate(redirectUrl);
    }
  }, [candidateId, errorMessage, isFileDownloaded, navigate]);

  return (
    <>
      <Snackbar open={errorMessage !== ''} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert severity="error">{errorMessage}</Alert>
      </Snackbar>
    </>
  );
}
